import { render, staticRenderFns } from "./drugSalesData.vue?vue&type=template&id=b70a07ba&scoped=true&"
import script from "./drugSalesData.vue?vue&type=script&lang=js&"
export * from "./drugSalesData.vue?vue&type=script&lang=js&"
import style0 from "./drugSalesData.vue?vue&type=style&index=0&id=b70a07ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70a07ba",
  null
  
)

export default component.exports